import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { SessionContext$reflection } from "../../CommonTypes.js";
import { union_type, record_type, list_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { LoadState$2, GlobalDependencies$reflection, LoadState$2$reflection } from "../../Global.js";
import { Json$reflection } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.fs.js";
import { Country$reflection } from "../../Containers/CustomerContract/Common.js";
import { createReducer, createAction } from "../Redux.js";

export class ModelState extends Record {
    constructor(SessionContext, GlobalDependencies, Translations, CountryTranslations, Countries) {
        super();
        this.SessionContext = SessionContext;
        this.GlobalDependencies = GlobalDependencies;
        this.Translations = Translations;
        this.CountryTranslations = CountryTranslations;
        this.Countries = Countries;
    }
}

export function ModelState$reflection() {
    return record_type("Redux.Reducers.Model.ModelState", [], ModelState, () => [["SessionContext", LoadState$2$reflection(SessionContext$reflection(), string_type)], ["GlobalDependencies", LoadState$2$reflection(GlobalDependencies$reflection(), string_type)], ["Translations", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)], ["CountryTranslations", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)], ["Countries", LoadState$2$reflection(list_type(Country$reflection()), string_type)]]);
}

export class ModelAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetSessionContext", "SetGlobalDependencies", "SetTranslations", "SetCountryTranslations", "SetCountries"];
    }
}

export function ModelAction$reflection() {
    return union_type("Redux.Reducers.Model.ModelAction", [], ModelAction, () => [[["Item", LoadState$2$reflection(SessionContext$reflection(), string_type)]], [["Item", LoadState$2$reflection(GlobalDependencies$reflection(), string_type)]], [["Item", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)]], [["Item", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)]], [["Item", LoadState$2$reflection(list_type(Country$reflection()), string_type)]]]);
}

export function setSessionContext(payload) {
    return createAction("ModelReducer", new ModelAction(0, payload));
}

export function setGlobalDependencies(payload) {
    return createAction("ModelReducer", new ModelAction(1, payload));
}

export function setTranslations(payload) {
    return createAction("ModelReducer", new ModelAction(2, payload));
}

export function setCountryTranslations(payload) {
    return createAction("ModelReducer", new ModelAction(3, payload));
}

export function setCountries(payload) {
    return createAction("ModelReducer", new ModelAction(4, payload));
}

export const initState = new ModelState(new LoadState$2(0), new LoadState$2(0), new LoadState$2(0), new LoadState$2(0), new LoadState$2(0));

function innerReducer(state, action) {
    switch (action.tag) {
        case 1: {
            return new ModelState(state.SessionContext, action.fields[0], state.Translations, state.CountryTranslations, state.Countries);
        }
        case 2: {
            return new ModelState(state.SessionContext, state.GlobalDependencies, action.fields[0], state.CountryTranslations, state.Countries);
        }
        case 3: {
            return new ModelState(state.SessionContext, state.GlobalDependencies, state.Translations, action.fields[0], state.Countries);
        }
        case 4: {
            return new ModelState(state.SessionContext, state.GlobalDependencies, state.Translations, state.CountryTranslations, action.fields[0]);
        }
        default: {
            return new ModelState(action.fields[0], state.GlobalDependencies, state.Translations, state.CountryTranslations, state.Countries);
        }
    }
}

export function reducer(stateOpt, action) {
    return createReducer("ModelReducer", initState, stateOpt, action, innerReducer);
}

